"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m10.21 16.83-1.96-2.36L5.5 18h11l-3.54-4.71z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M16.5 18h-11l2.75-3.53 1.96 2.36 2.75-3.54zM17 7h-3V6H4v14h14V10h-1z",
  opacity: ".3"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M20 4V1h-2v3h-3v2h3v2.99h2V6h3V4zm-2 16H4V6h10V4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V10h-2z"
}, "2")], 'AddPhotoAlternateTwoTone');